<template>
  <div>
    <div class="toolbar">
      <el-select v-model="projectId" clearable filterable placeholder="项目" style="width:200px" @change="load">
        <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
      </el-select>
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:180px" @change="load">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-select v-model="status" clearable placeholder="审核状态" style="width:130px" @change="load">
        <el-option v-for="o in materialReturnStatusFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建退货</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="returnNo" label="单号" width="160" />
      <el-table-column prop="projectName" label="项目" min-width="140">
        <template slot-scope="{ row }">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="供应商" min-width="130" />
      <el-table-column prop="status" label="审核状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(materialReturnStatusMap, row.status)">
            {{ statusLabel(materialReturnStatusMap, row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column prop="createdByName" label="创建人" width="80" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="90">
        <template slot-scope="{ row }">{{ formatDateOnly(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
          <el-button type="text" :disabled="!canEditRow(row)" @click="openEdit(row)">编辑</el-button>
          <el-button
            type="text"
            :disabled="row.status==='APPROVED'
              ? false
              : (row.status!=='SUBMITTED' && row.status!=='DRAFT')"
            @click="row.status==='APPROVED' ? onUnapprove(row) : onApprove(row)"
          >{{ row.status==='APPROVED' ? '反审' : '审批' }}</el-button>
          <el-button type="text" class="op-danger" :disabled="row.status!=='SUBMITTED' && row.status!=='DRAFT'" @click="onReject(row)">驳回</el-button>
          <el-button type="text" class="op-danger" :disabled="!canEditRow(row)" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑退货':'新建退货'" :visible.sync="visible" width="70%">
      <el-form :model="form" label-width="90px">
        <el-form-item label="项目" required>
          <el-select v-model="form.projectId" filterable style="width:100%" @change="onHeaderChange">
            <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" required>
          <el-select v-model="form.supplierId" filterable style="width:100%" @change="onHeaderChange">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
        <el-form-item label="明细" required>
          <el-button
            size="mini"
            type="primary"
            plain
            :disabled="!form.projectId||!form.supplierId"
            :loading="pickLoading"
            @click="openPickReceive"
          >选择收货明细</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px">
            <el-table-column prop="receiveNo" label="收货单号" width="140" show-overflow-tooltip />
            <el-table-column prop="reqNo" label="申请单号" width="140" show-overflow-tooltip />
            <el-table-column prop="materialName" label="材料" min-width="120" show-overflow-tooltip />
            <el-table-column prop="specs" label="规格" width="100" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.specs || '-' }}</template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" width="70" align="center" />
            <el-table-column prop="receiveQty" label="本次收货" width="90" />
            <el-table-column label="可退" width="80">
              <template slot-scope="{ row }">{{ remainOf(row) }}</template>
            </el-table-column>
            <el-table-column label="退货数量" width="140">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.qty"
                  :min="0.01"
                  :max="Number(remainOf(row) || 999999)"
                  :precision="2"
                  size="mini"
                  controls-position="right"
                />
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150">
              <template slot-scope="{ row }">
                <el-input v-model="row.remark" size="mini" placeholder="选填" />
              </template>
            </el-table-column>
            <el-table-column width="70">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.lines.splice($index,1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
          <p class="tip">从收货明细中勾选；同一申请明细不可重复选择。可退数量按申请明细累计实收扣减已退。</p>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择收货明细"
      :visible.sync="pickVisible"
      width="960px"
      append-to-body
      @closed="onPickClosed"
    >
      <div class="pick-toolbar">
        <el-input
          v-model="pickKeyword"
          clearable
          placeholder="收货单号 / 申请单号 / 材料 / 规格"
          style="width:280px"
        />
      </div>
      <el-table
        ref="pickTable"
        :data="pickFilteredList"
        border
        size="small"
        row-key="receiveLineId"
        v-loading="pickLoading"
        max-height="420"
        @selection-change="onPickSelectionChange"
      >
        <el-table-column type="selection" width="45" :selectable="pickSelectable" reserve-selection />
        <el-table-column prop="receiveNo" label="收货单号" width="140" show-overflow-tooltip />
        <el-table-column prop="reqNo" label="申请单号" width="140" show-overflow-tooltip />
        <el-table-column prop="materialName" label="材料" min-width="120" show-overflow-tooltip />
        <el-table-column prop="specs" label="规格" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.specs || '-' }}</template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="70" align="center" />
        <el-table-column prop="receiveQty" label="本次收货" width="90" />
        <el-table-column prop="remainQty" label="申请可退" width="90" />
        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="pickVisible=false">取消</el-button>
        <el-button type="primary" :disabled="!pickSelection.length" @click="confirmPick">添加所选</el-button>
      </div>
    </el-dialog>

    <el-drawer title="退货详情" :visible.sync="detailVisible" size="780px">
      <div style="padding:0 16px 16px" v-if="detail">
        <p>单号：{{ (detail.return || {}).returnNo }}</p>
        <p>
          审核：{{ statusLabel(materialReturnStatusMap, (detail.return || {}).status) }}
          <span v-if="(detail.return || {}).rejectReason"> · 驳回原因：{{ detail.return.rejectReason }}</span>
        </p>
        <p>项目：{{ (detail.return || {}).projectName }} · 供应商：{{ (detail.return || {}).supplierName }}</p>
        <el-table :data="detail.lines" border size="small">
          <el-table-column prop="receiveNo" label="收货单号" width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.receiveNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="reqNo" label="申请单号" width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.reqNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="materialName" label="材料" min-width="120" show-overflow-tooltip />
          <el-table-column label="规格" width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.specs || row.spec || '-' }}</template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="70" align="center" />
          <el-table-column prop="qty" label="退货数量" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  listMaterialReturns, getMaterialReturn, saveMaterialReturn,
  approveMaterialReturn, unapproveMaterialReturn, rejectMaterialReturn, deleteMaterialReturn,
  listSuppliers, listReturnableLines
} from '../../api/supply'
import { listProjects } from '../../api/project'
import { materialReturnStatusMap, materialReturnStatusFilterOptions, statusLabel, statusType } from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import ProjectNameLink from '../../components/ProjectNameLink.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'MaterialReturn',
  components: { ListPagination, ProjectNameLink },
  mixins: [listPaging],
  data() {
    return {
      materialReturnStatusMap,
      materialReturnStatusFilterOptions,
      projectId: null, supplierId: null, status: '',
      projects: [], suppliers: [], returnableOptions: [],
      list: [], loading: false, saving: false,
      visible: false, form: { lines: [] },
      detailVisible: false, detail: null,
      pickVisible: false,
      pickLoading: false,
      pickKeyword: '',
      pickSelection: []
    }
  },
  computed: {
    selectedReceiveLineIds() {
      return new Set((this.form.lines || []).map(l => l.receiveLineId).filter(Boolean))
    },
    selectedReqLineIds() {
      return new Set((this.form.lines || []).map(l => l.reqLineId).filter(Boolean))
    },
    pickFilteredList() {
      const kw = (this.pickKeyword || '').trim().toLowerCase()
      const list = this.returnableOptions || []
      if (!kw) return list
      return list.filter(m => {
        const text = [m.receiveNo, m.reqNo, m.materialName, m.specs, m.remark]
          .filter(Boolean).join(' ').toLowerCase()
        return text.indexOf(kw) >= 0
      })
    }
  },
  created() {
    this.loadMeta()
    const pid = Number(this.$route.query.projectId)
    if (pid) this.projectId = pid
    if (this.$route.query.status) this.status = this.$route.query.status
    this.load()
  },
  methods: {
    statusLabel, statusType,
    formatDateOnly(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    projectLabel(p) {
      return (p && (p.name || p.customerName)) || ''
    },
    async loadMeta() {
      const [p, s] = await Promise.all([listProjects({}), listSuppliers({})])
      this.projects = p.data || []
      this.suppliers = (s.data || []).filter(x => x.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReturns({
          projectId: this.projectId || undefined,
          supplierId: this.supplierId || undefined,
          status: this.status || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    remainOf(row) {
      const m = this.returnableOptions.find(x =>
        (row.receiveLineId && x.receiveLineId === row.receiveLineId)
        || (!row.receiveLineId && x.reqLineId === row.reqLineId)
      )
      if (m) return m.remainQty
      return row.remainQty != null ? row.remainQty : ''
    },
    async loadReturnable(clearLines = true) {
      if (!this.form.projectId || !this.form.supplierId) {
        this.returnableOptions = []
        if (clearLines) this.form.lines = []
        return
      }
      const res = await listReturnableLines({
        projectId: this.form.projectId,
        supplierId: this.form.supplierId,
        excludeReturnId: this.form.id || undefined
      })
      this.returnableOptions = res.data || []
      if (clearLines) {
        this.form.lines = []
        if (!this.returnableOptions.length) {
          this.$message.warning('该项目+供应商下暂无可退的收货明细')
        }
      }
    },
    async onHeaderChange() {
      await this.loadReturnable(true)
    },
    async openPickReceive() {
      if (!this.form.projectId || !this.form.supplierId) {
        return this.$message.warning('请先选择项目和供应商')
      }
      this.pickLoading = true
      this.pickKeyword = ''
      this.pickSelection = []
      try {
        await this.loadReturnable(false)
        if (!this.returnableOptions.length) {
          return this.$message.warning('暂无可退收货明细')
        }
        this.pickVisible = true
        this.$nextTick(() => {
          if (this.$refs.pickTable) this.$refs.pickTable.clearSelection()
        })
      } finally {
        this.pickLoading = false
      }
    },
    pickSelectable(row) {
      if (this.selectedReceiveLineIds.has(row.receiveLineId)) return false
      // 同一申请明细已在退货单中则不可再选（保存接口也不允许重复）
      if (this.selectedReqLineIds.has(row.reqLineId)) return false
      return true
    },
    onPickSelectionChange(rows) {
      this.pickSelection = rows || []
    },
    onPickClosed() {
      this.pickSelection = []
      this.pickKeyword = ''
    },
    confirmPick() {
      if (!this.pickSelection.length) return
      // 同一次勾选里同一申请明细只保留一行
      const byReq = {}
      for (const m of this.pickSelection) {
        if (!m.reqLineId) continue
        if (this.selectedReqLineIds.has(m.reqLineId) || this.selectedReceiveLineIds.has(m.receiveLineId)) continue
        if (byReq[m.reqLineId]) continue
        byReq[m.reqLineId] = m
      }
      const added = Object.values(byReq)
      if (!added.length) {
        return this.$message.warning('所选明细均已添加或同一申请明细重复')
      }
      for (const m of added) {
        const max = Number(m.remainQty) || 0
        const recv = Number(m.receiveQty) || 0
        const qty = Math.min(max, recv) || max
        this.form.lines.push({
          receiveLineId: m.receiveLineId,
          receiveNo: m.receiveNo,
          reqLineId: m.reqLineId,
          reqNo: m.reqNo,
          materialName: m.materialName,
          specs: m.specs || '',
          unit: m.unit || '',
          receiveQty: m.receiveQty,
          remainQty: m.remainQty,
          qty: qty > 0 ? qty : 0.01,
          remark: ''
        })
      }
      this.pickVisible = false
      this.$message.success(`已添加 ${added.length} 行`)
    },
    async openEdit(row) {
      if (!row) {
        this.form = { id: null, projectId: null, supplierId: null, remark: '', lines: [] }
        this.returnableOptions = []
        this.visible = true
        return
      }
      const res = await getMaterialReturn(row.id)
      const d = res.data || {}
      const r = d.return || {}
      this.form = {
        id: r.id,
        projectId: r.projectId,
        supplierId: r.supplierId,
        remark: r.remark,
        lines: []
      }
      await this.loadReturnable(false)
      this.form.lines = (d.lines || []).map(l => {
        const match = this.returnableOptions.find(x => x.reqLineId === l.reqLineId)
        return {
          receiveLineId: match ? match.receiveLineId : null,
          receiveNo: match ? match.receiveNo : '',
          reqLineId: l.reqLineId,
          reqNo: l.reqNo || (match && match.reqNo) || '',
          materialName: l.materialName || (match && match.materialName) || '',
          specs: (match && match.specs) || '',
          unit: l.unit || (match && match.unit) || '',
          receiveQty: match ? match.receiveQty : '',
          remainQty: match ? match.remainQty : Number(l.qty),
          qty: Number(l.qty),
          remark: l.remark || ''
        }
      })
      // 编辑时把已选但已无可退的行补进选项，避免可退显示空
      for (const l of this.form.lines) {
        if (l.reqLineId && !this.returnableOptions.some(x => x.reqLineId === l.reqLineId)) {
          this.returnableOptions.push({
            receiveLineId: l.receiveLineId,
            receiveNo: l.receiveNo,
            reqLineId: l.reqLineId,
            reqNo: l.reqNo,
            materialName: l.materialName,
            specs: l.specs,
            unit: l.unit,
            receiveQty: l.receiveQty,
            remainQty: l.qty
          })
        }
      }
      this.visible = true
    },
    async openDetail(row) {
      const res = await getMaterialReturn(row.id)
      this.detail = res.data
      this.detailVisible = true
    },
    async save() {
      const f = this.form
      if (!f.projectId || !f.supplierId) return this.$message.warning('请选择项目和供应商')
      if (!f.lines.length || f.lines.some(l => !l.reqLineId || !l.qty)) {
        return this.$message.warning('请选择收货明细并填写退货数量')
      }
      this.saving = true
      try {
        await saveMaterialReturn({
          id: f.id || undefined,
          projectId: f.projectId,
          supplierId: f.supplierId,
          remark: f.remark,
          lines: f.lines.map(l => ({
            reqLineId: l.reqLineId,
            qty: l.qty,
            remark: (l.remark || '').trim() || undefined
          }))
        })
        this.$message.success('已保存，等待审批')
        this.visible = false
        this.load()
      } finally { this.saving = false }
    },
    canEditRow(row) {
      return row && (row.status === 'SUBMITTED' || row.status === 'REJECTED' || row.status === 'DRAFT')
    },
    onApprove(row) {
      this.$confirm('确认审批通过？', '审批').then(async () => {
        await approveMaterialReturn(row.id); this.$message.success('已审批'); this.load()
      }).catch(() => {})
    },
    onUnapprove(row) {
      this.$confirm('反审后将变回待审批，是否继续？', '反审', { type: 'warning' }).then(async () => {
        await unapproveMaterialReturn(row.id)
        this.$message.success('已反审')
        this.load()
      }).catch(() => {})
    },
    onReject(row) {
      this.$prompt('请输入驳回原因', '驳回', { inputPattern: /\S+/, inputErrorMessage: '请填写原因' })
        .then(async ({ value }) => {
          await rejectMaterialReturn(row.id, value)
          this.$message.success('已驳回')
          this.load()
        }).catch(() => {})
    },
    onDelete(row) {
      this.$confirm('删除退货单？', '提示', { type: 'warning' }).then(async () => {
        await deleteMaterialReturn(row.id); this.$message.success('已删除'); this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.tip { margin:8px 0 0; font-size:12px; color:#94a3b8; }
.pick-toolbar { margin-bottom:10px; }
</style>
